@if (showWindow) {
  <div class="list">
    <ul class="list-alert-head">
      <li class="alert-window-padding-reset" (click)="closeAlerts()" (keydown.enter)="closeAlerts()" tabindex="0" role="button">
        @if (windowUnreadCount > 0) {
          <span class="unreadCount">{{ windowUnreadCount }}</span>
        }
        <img alt="" src="../../../../assets/img/Green.svg" class="alert-icon" />
        Alerts
        <span #closeBtn class="cross-button" tabindex="0" role="button" (keyup.enter)="closeAlerts()"
          ><img alt="Close" src="../../../../assets/img/close-green.svg" class="caret-icon" aria-hidden="true" /><span class="sr-only">Close Alerts</span></span
        >
      </li>
    </ul>
    @if (!showListLoader && alertsData?.length === 0) {
      <ul class="list-alert-items">
        <li class="no-alerts">You don't have any alerts.</li>
      </ul>
    }
    @if (!showListLoader) {
      <ul class="list-alert-items">
        @for (alert of alertsData; track alert; let i = $index) {
          <li id="alert.alertId">
            <a tabindex="0" role="button" (keyup.enter)="$event.target.click()" (click)="showAlertDetail(alert)">
              <span class="alert-bullet" [ngClass]="{ 'unread-bullet': !alert.unread }"></span>
              <span class="alert-message" [ngClass]="{ 'unread-message': alert.unread }">{{ alert.alertMessage }}</span>
              <span class="alert-date">{{ alert.alertDateTime | date: 'MM/dd/yyyy' : 'UTC' }}</span>
              <span class="alert-caret">
                <img [ngClass]="{ rotate: alert.isMessageShow }" alt="Expand Alerts Dropdown" src="../../../../assets/img/dropdown.svg" class="caret-icon" />
              </span>
            </a>
            @if (alert.isMessageLoaded && alert.isMessageShow) {
              <app-alert-message-detail [id]="'alert-detail-' + alert.alertId" [messageContent]="alert.messageContent"></app-alert-message-detail>
            }
            @if (!alert.isMessageLoaded && alert.isMessageShow) {
              <mat-spinner [diameter]="25" class="page-loader"> </mat-spinner>
            }
          </li>
        }
        @if (showSeeMore) {
          <li class="see-more">
            @if (!showSeeMoreLoader) {
              <a tabindex="0" role="button" (keyup.enter)="$event.target.click()" (click)="onSeeMore($event)">See more</a>
            }
            @if (showSeeMoreLoader) {
              <mat-spinner [diameter]="20" class="page-loader"></mat-spinner>
            }
          </li>
        }
      </ul>
    }
    @if (showListLoader) {
      <ul class="list-alert-items">
        <li>
          <mat-spinner [diameter]="50" class="page-loader"></mat-spinner>
        </li>
      </ul>
    }
  </div>
}
